export const STORAGE_KEY = {
  AccessToken: "accessToken",
  RefreshToken: "refreshToken",
  IdToken: "idToken",
  Email: "email",
  Username: "username",
  Company: "company",
  Role: "role",
  IsLoggedIn: "isLoggedIn",
  LoginTimestamp: "loginTimestamp",
  RememberEmail: "rememberEmail",
} as const;
